// @flow

import React from "react";

import Section from "../../components/Section";
import EditableForm from "../../components/EditableForm";
import FormRow from "../../components/FormRow";
import EditableField from "../../components/EditableField";

import {
  IS_ALREADY_SELF_EMPLOYED,
  IS_BANKRUPT,
  IS_SME,
  HAS_SHARES_IN_OTHER_COMPANY
} from "./formFields";
import { mapBoolean } from "./mappers";

type OkpAffirmationInfoProps = {
  initialValues: {
    [IS_ALREADY_SELF_EMPLOYED]: boolean,
    [IS_BANKRUPT]: boolean,
    [IS_SME]: boolean,
    [HAS_SHARES_IN_OTHER_COMPANY]: boolean
  },
  numberedWithDot?: boolean
};

const OkpAffirmationInfo = ({ initialValues, numberedWithDot }: OkpAffirmationInfoProps) => (
  <Section title="Bestätigungen" reducedMargin numberedWithDot={numberedWithDot}>
    <EditableForm initialValues={initialValues} isLocked>
      <FormRow>
        <EditableField
          fieldControlProps={{
            name: IS_BANKRUPT,
            caption: () => "Bestehen insolvenzrechtliche oder strafrechtliche Zwangsmaßnahmen?"
          }}
          displayValue={mapBoolean}
        />

        <EditableField
          fieldControlProps={{
            name: IS_SME,
            caption: () => "Erfüllt das Unternehmen die KMU-Kriterien?"
          }}
          displayValue={mapBoolean}
        />
      </FormRow>

      <FormRow>
        <EditableField
          fieldControlProps={{
            name: IS_ALREADY_SELF_EMPLOYED,
            caption: () => "Besteht bereits eine Selbständigkeit?"
          }}
          displayValue={mapBoolean}
        />

        <EditableField
          fieldControlProps={{
            name: HAS_SHARES_IN_OTHER_COMPANY,
            caption: () => "Besteht eine Beteiligung an anderen Unternehmen?"
          }}
          displayValue={mapBoolean}
        />

        <div />
      </FormRow>
    </EditableForm>
  </Section>
);

OkpAffirmationInfo.defaultProps = {
  numberedWithDot: false
};

export default OkpAffirmationInfo;
